module.exports = __webpack_public_path__ + "./images/535f50ec0679b7de251ce221e1253064.png";